import type { HTMLProps, ReactElement } from 'react';
import React from 'react';
import cx from 'classnames';

import type { SkeletonSize } from './Skeleton.types';

import styles from './Skeleton.module.scss';

type SkeletonProps = HTMLProps<HTMLDivElement> & {
	height?: SkeletonSize;
	isAnimated?: boolean;
	isFullWidth?: boolean;
	testId?: string;
	width?: SkeletonSize;
};

export const DEFAULT_SKELETON_TEST_ID = 'skeleton-placeholder';

const Skeleton = ({
	className,
	height = 3,
	isAnimated = true,
	isFullWidth,
	testId = DEFAULT_SKELETON_TEST_ID,
	width = 5,
	...props
}: SkeletonProps): ReactElement => (
	<div
		aria-busy="true"
		className={cx(
			styles.box,
			styles[`height-${height}`],
			{
				[styles[`width-${width}`]]: !isFullWidth,
				[styles.animated]: isAnimated,
				[styles.fullWidth]: isFullWidth,
			},
			className,
		)}
		data-testid={testId}
		{...props}
	/>
);

export default Skeleton;
